import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="sprout-workbook-paper sprout-paper-lift relative overflow-hidden rounded-[2rem_2rem_2rem_0.5rem] border-2 border-navy-ink px-8 py-16 text-navy-ink before:absolute before:inset-y-0 before:left-0 before:w-3 before:bg-coral after:absolute after:-right-12 after:-top-12 after:size-36 after:rounded-full after:bg-sunflower md:px-14 md:py-24 lg:px-20 lg:py-28">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          className="relative z-10"
          headingClassName="max-w-[15ch] text-5xl md:text-7xl lg:text-8xl"
        />
      </div>
    </SproutSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
